import { render, staticRenderFns } from "./StatsDefaulter.vue?vue&type=template&id=331808d3&scoped=true"
import script from "./StatsDefaulter.vue?vue&type=script&lang=js"
export * from "./StatsDefaulter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.38_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_xsnsr4smgwphgcec6u2nh24t5a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331808d3",
  null
  
)

export default component.exports